import React, { useState } from 'react';
import {
  DEV_PREVIEW_OPTIONS,
  getDevPreviewDomainKey,
  setDevPreviewDomainKey
} from '../../utils/hostname';

const switcherWrapperStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.35rem 0.75rem',
  borderRadius: '999px',
  backgroundColor: 'rgba(255, 255, 255, 0.92)',
  color: '#1d2b44',
  fontSize: '0.9rem',
  fontWeight: 600
};

const selectStyle = {
  border: '1px solid #c4cbd7',
  borderRadius: '999px',
  backgroundColor: '#ffffff',
  color: '#1d2b44',
  fontSize: '0.85rem',
  fontWeight: 600,
  padding: '0.3rem 2rem 0.3rem 0.75rem',
  minWidth: '240px'
};

const infoButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '18px',
  height: '18px',
  borderRadius: '999px',
  backgroundColor: '#1d2b44',
  color: '#ffffff',
  fontSize: '0.75rem',
  fontWeight: 700,
  cursor: 'help',
  position: 'relative',
  border: 0,
  padding: 0,
  lineHeight: 1
};

const tooltipStyle = {
  position: 'absolute',
  top: 'calc(100% + 10px)',
  right: 0,
  width: '320px',
  padding: '0.75rem 0.9rem',
  borderRadius: '12px',
  backgroundColor: '#1d2b44',
  color: '#ffffff',
  fontSize: '0.8rem',
  fontWeight: 500,
  lineHeight: 1.4,
  boxShadow: '0 12px 24px rgba(9, 18, 36, 0.28)',
  zIndex: 20,
  pointerEvents: 'none',
  textAlign: 'left'
};

const DevDomainSwitcher = () => {
  const selectedPreviewDomain = getDevPreviewDomainKey();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipText =
    'Podglad dostepny tylko na domenie developerskiej i na localhost. Na rzeczywistych domenach produkcyjnych ten przelacznik nie jest wyswietlany.';

  const handleChange = (event) => {
    const value = event.target.value || null;

    setDevPreviewDomainKey(value);
    window.location.reload();
  };

  return (
    <div style={switcherWrapperStyle}>
      <span>Preview</span>
      <button
        aria-label={tooltipText}
        onBlur={() => setIsTooltipVisible(false)}
        onFocus={() => setIsTooltipVisible(true)}
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        style={infoButtonStyle}
        type="button">
        i{isTooltipVisible && <span style={tooltipStyle}>{tooltipText}</span>}
      </button>
      <select
        aria-label="Preview domeny"
        onChange={handleChange}
        style={selectStyle}
        value={selectedPreviewDomain}>
        {DEV_PREVIEW_OPTIONS.map((option) => (
          <option key={option.hostname} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DevDomainSwitcher;
